export const PRODUCT_NAME = 'visa'
